"use strict";
import { gsap } from "gsap"; 
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/* transition page */
const links = document.querySelectorAll('.link-anim-close');

links.forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();

    const linkHref = event.currentTarget.href;
    const transitionLeft = document.querySelector('.transition--left');
    const transitionRight = document.querySelector('.transition--right');

    transitionLeft.classList.add('animation--close-left');
    transitionRight.classList.add('animation--close-right');

    transitionLeft.addEventListener('animationend', function() {
      transitionLeft.classList.remove('animation--close-left');
      transitionRight.classList.remove('animation--close-right');
      window.location.href = linkHref;
    }, { once: true });
  });
});

/* apparition album */
if (document.body.classList.contains("body--home")) {
  gsap.from(".album__gdi", {
    x: -50,
    ease: "easeInOut",
    scrollTrigger: {
      trigger: ".album__vinyl",
      start: "top 100%",
      end: "top 50%",
      scrub: 1.5,
    }
  });
  gsap.from(".album__vinyl", {
    x: -250,
    ease: "easeInOut",
    scrollTrigger: {
      trigger: ".album__vinyl",
      start: "top 100%",
      end: "top 50%",
      scrub: 1.5,
    }
  });
  gsap.to(".album__vinyl", {
    rotation: 360,
    duration: 10,
    ease: "linear",
    repeat: -1,
    transformOrigin: "center center",
  });
}
document.querySelectorAll(".fade-right").forEach((element) => {
  gsap.from(element, {
    x: -100,
    opacity: 0,
    stagger: 0.5,
    ease: "linear",
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "top 90%",
      scrub: 1.5,
    }
  });
});

/* menu sticky */
let lastScrollY = window.scrollY;
window.addEventListener('scroll', () => {
  const header = document.querySelector('header');
  if (window.scrollY > lastScrollY) {
    header.classList.add('hidden');
  } else {
    header.classList.remove('hidden');
  }
  lastScrollY = window.scrollY;
});

/* border menu */
document.addEventListener('scroll', () => {
  const nav = document.querySelector('nav.menu');
  if (window.scrollY > 0) {
      nav.classList.remove('menu--start');
  } else {
      nav.classList.add('menu--start');
  }
});

/* tracklist */
let choixmusique = null;
let play = false;
let currentAudio = null;
const buttons = document.querySelectorAll('.tracklist__el button');
const tracklistBtn = document.querySelector(".tracklist__button");
const select = document.querySelector('.select__musics');

/* anim tracklist */
function startAnimation() {
  gsap.to(tracklistBtn, {
    scale: 1.1,
    duration: 0.2,
    ease: "power4.inOut",
    repeat: -1,
    yoyo: true
  });
}
function stopAnimation() {
  gsap.killTweensOf(tracklistBtn);
  gsap.to(tracklistBtn, { 
    scale: 1,
    duration: 0.2,
    ease: "power4.inOut"
  });
}

/* fonction pour gérer la lecture de l'audio */
function playAudio(trackIndex) {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio.removeEventListener('ended', handleTrackEnd);
  }
  if (play && trackIndex !== null) {
    currentAudio = new Audio(`/musicplz/assets/musiques/${trackIndex}.mp3`);
    currentAudio.play().then(() => {
      console.log(`Lecture de la musique numéro ${trackIndex}`);
    }).catch(error => {
      console.error("Erreur de lecture audio :", error);
    });
    currentAudio.addEventListener('ended', handleTrackEnd);
  } else {
    console.log("Stop audio");
  }
}

/* fonction appelée quand une musique se termine */
function handleTrackEnd() {
  choixmusique++;
  if (choixmusique > buttons.length) {
    choixmusique = 1;
  }
  buttons.forEach(b => b.classList.remove('active'));
  buttons[choixmusique - 1].classList.add('active');
  select.selectedIndex = choixmusique - 1;
  playAudio(choixmusique);
  changeImage(choixmusique);
}

/* boutons tracklist */
buttons.forEach((button, index) => {
  button.addEventListener('click', () => {
    if (button.classList.contains('active') && play) {
      button.classList.remove('active');
      play = false;
      stopAnimation();
      choixmusique = null;
      playAudio(null);
      return;
    } else if (!play) {
      play = true;
      startAnimation();
    }
    buttons.forEach(b => b.classList.remove('active'));
    button.classList.add('active');
    choixmusique = index + 1;
    select.selectedIndex = index;
    playAudio(choixmusique);
    changeImage(choixmusique); 
  });
});

/* image tracklist */
if (tracklistBtn) {
  tracklistBtn.addEventListener('click', () => {
    if (!currentAudio) {
      console.log("Aucune musique sélectionnée.");
      return;
    }
    if (currentAudio.paused && choixmusique != null) {
      play = true;
      startAnimation();
      currentAudio.play().then(() => {
        console.log("Lecture relancée.");
      }).catch(error => {
        console.error("Erreur lors de la reprise de la lecture :", error);
      });
    } else {
      play = false;
      stopAnimation();
      currentAudio.pause();
      console.log("Lecture mise en pause.");
    }
  });
}

/* select tracklist */
if (select) {
  select.addEventListener('change', (event) => {
    if (!play) {
      play = true;
      startAnimation();
    }
    choixmusique = event.target.selectedIndex + 1;
    buttons.forEach(b => b.classList.remove('active'));
    buttons[choixmusique - 1].classList.add('active');
    playAudio(choixmusique);
    changeImage(choixmusique); 
  });
}

/* changement d'images */
const tracklistImage = document.querySelector(".tracklist__img");
function changeImage(trackIndex) {
  if (!tracklistImage) return;
  const imageSrc = `/musicplz/assets/images/${trackIndex}.webp`;
  const imageSrc2x = `/musicplz/assets/images/${trackIndex}@2x.webp`;
  tracklistImage.setAttribute("src", imageSrc);
  tracklistImage.setAttribute("srcset", `${imageSrc2x} 2x`);
  tracklistImage.setAttribute("alt", `la preview de la chanson ${trackIndex}`);
}